import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-account-tab4',
  templateUrl: './my-account-tab4.component.html',
  styleUrls: ['./my-account-tab4.component.scss']
})
export class MyAccountTab4Component implements OnInit {
  MATitle = 'Contact Preferences'
  MAPreferencesSend = {
    sendUpdates: 'Send me occasional new updates and special offers',
    sendReminder: 'Send me reminders to update my plan'
  }
  constructor() { }

  ngOnInit() {
  }

}
